import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemoveEducationFromCandidateResponse extends BackendResponse {}
export interface RemoveEducationFromCandidateParameters extends NextApiParams {
  educationId: number;
}

export const removeEducationFromCandidate = withNextApi<
  RemoveEducationFromCandidateResponse,
  RemoveEducationFromCandidateParameters
>("/cvp/CvpRemoveEducationFromCandidate");
